import { Routes } from "./config/Routes";
import Layout from "./layout/Layout";
import { useRoutes } from "react-router";
import { Suspense, useEffect } from "react";
import TermsCondition from "./Components/TermsCondition";
import AllCookies from "./Components/AllCookies";
import { generateSitemap, saveSitemapXml } from "./config/generateSitemap";
import { HashLoader } from "react-spinners";

function App() {
  const elements = useRoutes(Routes);

  useEffect(() => {
    window.scrollTo(0, 0);
    generateSitemap();
  }, [elements]);

  return (
    <>
      <Suspense
        fallback={
          <div className="loader-overlay">
            <HashLoader color="#008ddf" size={100} className="loader" />
          </div>
        }
      >
        <Layout>
          {elements}
          <AllCookies />
        </Layout>
      </Suspense>
    </>
  );
}

export default App;
